export default "/credits/business/assets/019e00d17b6d741e4238ca800bdede7b.svg";